import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { EditorHtmlField, useModel, useSettings, Utils } from 'app/main/components';

interface NotesAddDialogProps {
	model: any;
	isUpdate?: boolean;
	updateRefresh?: () => void;
}

export const showAddNotesDialog = (props: NotesAddDialogProps) =>
	openDialog({
		children: <NotesAddDialog {...props} />,
		maxWidth: 'sm',
		fullWidth: true,
		onClose: () => {}
	});

export default function NotesAddDialog({ model: baseModel, isUpdate, updateRefresh }: NotesAddDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings('notes');

	const { model, sendChange, save } = useModel({ baseModel, settings, isEdit: true, isAdd: !isUpdate });

	const addNote = () => {
		save({
			storedName: 'st_notes_manager',
			onSuccess: () => {
				dispatch(Utils.alertSuccessMsg(t, !isUpdate ? 'ALERT_ADD_SUCCESS' : 'ALERT_UPDATE_SUCCESS'));
				dispatch(closeDialog());
				if (updateRefresh) updateRefresh();
			}
		});
	};

	return (
		<>
			<DialogTitle>{t(isUpdate ? 'DIALOG_TITLE_NOTES_EDIT' : 'DIALOG_TITLE_NOTES_ADD')}</DialogTitle>
			<DialogContent>
				<EditorHtmlField
					name="note_descriptionhtml"
					value={model.note_descriptionhtml}
					sendChange={sendChange}
					isEdit
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_BACK')}</Button>
				<Button color="secondary" onClick={addNote}>
					{t(isUpdate ? 'DIALOG_ACTION_SAVE' : 'DIALOG_ACTION_ADD')}
				</Button>
			</DialogActions>
		</>
	);
}
